import _deployments from "./deployments.json"

export const DEPLOYMENTS = _deployments
